import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { RootState } from '../reduxStore/store';

interface Coupon {
    title:string;
    points:number;
    end_date:string;
    
}

interface CurrentUserState {
  coupons: Coupon[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CurrentUserState = {
  coupons: null,
  loading: false,
  error: null,
};

interface ErrorResponse {
  message: string;
}

// Async thunk to fetch the current user data
export const getPointHistry = createAsyncThunk<Coupon[], void, { rejectValue: ErrorResponse, state: RootState }>(
  'coupons/getCoupons',
  async (_, thunkAPI) => {
    const token = localStorage.getItem('accessToken');
    console.log("Token for fetching data " + token);
    console.log("This is work")

    if (!token) {
      return thunkAPI.rejectWithValue({ message: 'No token available' });
    }

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await axios.get(`${apiUrl}${shop_domain}/api/v1/customer/history`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return thunkAPI.rejectWithValue({ message: error.response.data.message || 'An error occurred' });
      }
      return thunkAPI.rejectWithValue({ message: 'An unknown error occurred' });
    }
  }
);



const transactionSlice = createSlice({
  name: 'coupons',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPointHistry.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPointHistry.fulfilled, (state, action: PayloadAction<Coupon[]>) => {
        state.loading = false;
        state.coupons = action.payload;
        state.error = null;
      })
      .addCase(getPointHistry.rejected, (state, action: PayloadAction<ErrorResponse | undefined>) => {
        state.loading = false;
        state.error = action.payload?.message || 'Unknown error';
      });
  },
});

export default transactionSlice.reducer;
